import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'

export class KpiSaleConfigService extends BaseService {
  static async kpiPolicyConfig(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.standard-filter'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigCreate(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.create-service-kpi'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigView(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigCreateAttribute(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.create-kpi-policy'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigApproveAttribute(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.approve-kpi-policy'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigLockAttribute(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.lock-kpi-policy'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiPolicyConfigUpdateAttribute(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.perf.kpi-policy.update-kpi-policy'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getServiceList() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-package-config'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
